import React from "react";
import Hero from "../components/landing/Hero";
import StatsStrip from "../components/landing/StatsStrip";
import Features from "../components/landing/Features";
import Preview from "../components/landing/Preview";
import Audience from "../components/landing/Audience";
import SecurityIntegrations from "../components/landing/SecurityIntegrations";
import Pricing from "../components/landing/Pricing";
import FAQ from "../components/landing/FAQ";
import FooterCTA from "../components/landing/FooterCTA";
import Footer from "../components/landing/Footer";

import {
  NAV,
  STATS,
  FEATURES,
  PREVIEW_TABS,
  PLANS,
  FAQS,
} from "../data/landingData";
import Background from "../components/landing/Background";
import Navbar from "../components/landing/Navbar";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen text-white">
      <Background />

      <Navbar
        brand="BotX"
        items={NAV}
        primaryCta={{
          label: "Dodaj bota",
          href: "http://localhost:3000/v1/auth",
        }}
        secondaryCta={{ label: "Dashboard", href: "#" }}
      />

      <main>
        <Hero
          title="Jeden bot, porządek na serwerze i więcej czasu dla Ciebie."
          subtitle="Moderacja, tickety, automatyzacje i ekonomia — sterowane z dashboardu."
          primaryCta={{
            label: "Dodaj bota",
            href: "https://discord.com/oauth2/authorize",
          }}
          secondaryCta={{ label: "Otwórz Dashboard", href: "#" }}
          badges={[
            "24/7 Uptime",
            "Weryfikacja anty-spam",
            "Konfiguracja w 2 min",
          ]}
        />

        <StatsStrip stats={STATS} />

        <Features items={FEATURES} />

        <Preview tabs={PREVIEW_TABS} />

        <Audience />

        <SecurityIntegrations />

        <Pricing plans={PLANS} />

        <FAQ items={FAQS} />

        <FooterCTA
          title="Dodaj bota w 30 sekund."
          subtitle="Zacznij od presetu. Dopracuj moduły, kiedy chcesz."
          primaryCta={{
            label: "Dodaj bota",
            href: "https://discord.com/oauth2/authorize",
          }}
          secondaryCta={{ label: "Dołącz na support", href: "#" }}
        />
      </main>

      <Footer />
    </div>
  );
}
